import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {
  /**
   * Persist the object of type U in the localStorage
   * @param U - Object type
   */
  public save<U>(key: string, object: U) {
    localStorage.setItem(key, JSON.stringify(object));
  }

  /**
   * Read the content of the localStorage for the given key,
   * This should return an object of type U.
   */
  public get<U>(key: string): U | undefined {
    const dataRaw: string | null = localStorage.getItem(key);
    if (dataRaw === null) {
      return undefined;
    }
    return JSON.parse(dataRaw);
  }

  /**
   * Remove an item from localStorage
   */
  public remove(key: string): void {
    localStorage.removeItem(key);
  }
}
